import { FormDocumentBase } from './form-document-base';

export class FormHealthRecordDocument extends FormDocumentBase {
  documentDate: Date | null;
  documentType: number | null;
  healthRecordId: string;
  isUploadedByClinic: boolean;

  constructor() {
    super();
    this.comment = '';
    this.documentDate = null;
    this.documentType = null;
    this.fileDate = null;
    this.fileName = '';
    this.fileSizeBytes = 0;
    this.healthRecordId = '';
    this.isUploadedByClinic = false;
  }
}
